module.exports = __webpack_public_path__ + "img/direct.99098eda.png";